var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 11,
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2841 0.965879C14.6136 1.29538 14.6136 1.82962 14.2841 2.15912L6.40912 10.0341C6.07962 10.3636 5.54538 10.3636 5.21588 10.0341L0.715879 5.53412C0.386374 5.20462 0.386374 4.67038 0.715879 4.34088C1.04538 4.01137 1.57962 4.01137 1.90912 4.34088L5.8125 8.24426L13.0909 0.965879C13.4204 0.636374 13.9546 0.636374 14.2841 0.965879Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-icon.ccbdae30747824a415853d4ab191b570.svg";